;
(function ($) {
  var dataKey = 'app.totals';
  var Totals = function Totals(element, options) {
    this.element = element;
    this.init(options);
  };
  Totals.prototype = {
    attr: {
      groupItem: 'data-total-group',
      groupTotal: 'data-total',
      grandTotal: 'data-total-grand',
      noCalculate: 'data-total-nocalculate',
      income: 'data-income',
      outgoings: 'data-outgoings',
      arrears: 'data-arrears'
    },
    /**
     * Initialise Totals
     * Initialises the totals plugin
     * @public
     * @constructor
     * @param {string} options - Apply and extend options into init if needed.
     */

    init: function init(options) {
      $.extend(this.options, options);
      var _this = this;
      var total = 0;
      $('[' + this.attr.groupItem + ']').on('change', function () {
        var group = $(this).attr(_this.attr.groupItem);
        total = 0;
        $('body').find('[' + _this.attr.groupItem + '="' + group + '"]').each(function () {
          var val = $(this).val().replace(',', '');
          if (val) {
            total = total + parseFloat(val);
          }
        });
        _this.setGroupTotal(group, total);
        _this.setGrandTotal();
      });
    },
    /**
     * Set Group Total
     * Add all input values within the group and updates the group total element.
     * @private
     * @param {element} group - The element containing the group total.
     * @param {element} total - The added total of all group values.
     */

    setGroupTotal: function setGroupTotal(group, total) {
      $('[' + this.attr.groupTotal + '="' + group + '"]').html('£' + $.number(total, 2));
    },
    /**
     * Set Grand Total
     * Add all group total element values and update the grand total element.
     * @private
     */

    setGrandTotal: function setGrandTotal() {
      var _this = this;
      var total = 0;
      var income = '[' + this.attr.income + ']';
      var outgoings = '[' + this.attr.outgoings + ']';
      var arrears = '[' + this.attr.arrears + ']';
      var buttonText = "";
      if ($(income).is(':visible')) {
        buttonText = 'Apply Income: £';
      } else if ($(outgoings).is(':visible')) {
        buttonText = 'Apply Outgoings: £';
      } else if ($(arrears).is(':visible')) {
        buttonText = 'Apply Arrears: £';
      } else {
        buttonText = '£';
      }
      $('body').find('[' + this.attr.groupTotal + ']:not([' + this.attr.noCalculate + '])').each(function () {
        var val = $(this).html().replace('£', '').replace(',', '');
        if (val) {
          total = total + parseFloat(val);
        }
      });
      $('[' + _this.attr.grandTotal + ']').html(buttonText + $.number(total, 2));
    }
  };

  /**
   * Global callback function which by default all [data-total] triggers this plugin.
   * @method $.fn.app_totals()
   * @public
   * @constructor
   * @param {string} options
   * @optional options
   * @example $(element).app_totals();
   */

  $.fn.app_totals = function (options) {
    var plugin = this.data(dataKey);
    if (plugin instanceof Totals) {
      if (typeof options !== 'undefined') {
        plugin.init(options);
      }
    } else {
      plugin = new Totals(this, options);
      this.data(dataKey, plugin);
    }
    return plugin;
  };
})(jQuery, window, document);